import { useEffect } from 'react';
import { history } from 'routes/history';
import { BASE_PATH } from 'constants/index';
import { TRANSFER_OTP, PENDING_OTP } from 'constants/statusProcess';
import { IBAN_TRANSFER_OTP_SEND_OTP } from 'constants/identityMethod';

export const useFetchUserStatus = ({
    changeUserStatusCall,
    fetchOTPTransferData,
    hidePreLoader,
    ibanTransferOTPCall,
    showPreLoader,
    userProfile,
}) => {
    useEffect(() => {
        const sendOtp = async () => {
            const sendOtpCall = await ibanTransferOTPCall(userProfile.accessToken, 'POST', IBAN_TRANSFER_OTP_SEND_OTP);
            if (sendOtpCall.status === 'OK') {
                await fetchOTPTransferData();
            } else {
                throw new Error('Failed to send OTP');
            }
        };

        const fetchData = async () => {
            showPreLoader();
            try {
                const { status } = await changeUserStatusCall(userProfile.accessToken, 'RETURN_STATUS');
                if (status === TRANSFER_OTP) {
                    await sendOtp();
                } else if (status === PENDING_OTP) {
                    await fetchOTPTransferData();
                }
            } catch (error) {
                history.push(`${BASE_PATH}/errors`);
            } finally {
                hidePreLoader();
            }
        };

        fetchData();
    }, [changeUserStatusCall, userProfile, showPreLoader, hidePreLoader, fetchOTPTransferData, ibanTransferOTPCall]);
};
